import React from "react";
import "./Coach.css";
import coachImg from "../Images/coachImg.png";
import interviewers from "../Images/interviewers.png";
import mentorship from "../Images/mentorship.png";
import resume from "../Images/resume.png";
import { Link } from 'react-router-dom';

const Coach = () => {


  return (
    <>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <main className="sh-landing-container">
        {/* Career Coach Section */}
        <section className="sh-section" >
          <div className="sh-text-left-ch">
            <h2>CAREER COACHES & MENTORS</h2>
            <p className="tag"> Shape careers, share your wisdom, and monetize your  mentoring </p>
            <p className="tag1">
  Career Coaches,<br /> Resume Experts Interview <br />Trainers & <span className="hh">Professionals</span>
</p>

            <p className="tag2">
              Your guidance can transform someone’s career journey. As a SkillsHap mentor, you’ll provide resume feedback, career clarity, interview prep, and mindset training. Get paid per session and grow your brand while making a direct difference in real lives.
            </p>
            {/* <a
            href="https://forms.gle/B9ZHm3azzM9suzsN9"
            target="_blank"
            rel="noopener noreferrer"
          > */}
            <Link to="/RedirectToForm"> <button className="sh-secondary-btn">Connect Now</button> </Link>
          {/* </a> */}

          </div>
          <div className="sh-img-right-ch">
            <img src={coachImg} alt="Career Coach" />
          </div>

          <div className="career-services">
            <div className="service-card">
              <img src={interviewers} alt="Interviewers" className="service-image" />
              <h3 className="service-title">Interviewers</h3>
              <p className="service-text">
                Our interview preparation service offers mock interviews and real-time feedback
                from expert interviewers to help you build confidence, polish your communication, and master answering challenging questions.
                Whether it’s your first interview or your next career leap, we ensure you’re ready to impress.
              </p>
            </div>

            <div className="service-card">
              <img src={mentorship} alt="Mentorship" className="service-image" />
              <h3 className="service-title">Mentorship Guidance</h3>
              <p className="service-text">
                Connect with experienced industry mentors to receive valuable guidance, personalized advice,
                and career insights that align with your goals. Whether you're exploring new paths or navigating
                career transitions, our mentorship program provides the clarity and direction you need to grow professionally.
              </p>
            </div>

            <div className="service-card">
              <img src={resume} alt="Resume Services" className="service-image" />
              <h3 className="service-title">Resume Writing Services</h3>
              <p className="service-text">
                Our professional resume writers create tailored, ATS-friendly resumes that showcase your strengths,
                achievements, and career aspirations. With industry-aligned formatting and compelling content,
                we help you stand out and make a strong first impression in any hiring process.
              </p>
            </div>
          </div>

        </section>
      </main>
    </>
  );
};

export default Coach;